
import Footer from '../../TheamLayout/Footer';
import Header from '../../TheamLayout/Header';
import Main from './Main'

const Services = () => {
  return <>
   <Header/>
  <Main/>
  <Footer/>
  </>;
};

export default Services;
